export const COLOR_PALETTE = [
    { name: '레드', value: '#ff0000' },
    { name: '바이올렛', value: '#8a2be2' },
    { name: '핑크', value: '#ffb6c1' },
    { name: '핫핑크', value: '#ff1493' },
    { name: '옐로우', value: '#ffff00' },
    { name: '오렌지', value: '#ffa500' },
    { name: '라임', value: '#bfff00' },
    { name: '그린', value: '#008000' },
    { name: '카키', value: '#808000' },
    { name: '스카이블루', value: '#87ceeb' },
    { name: '블루', value: '#0000ff' },
    { name: '네이비', value: '#000080' },
    { name: '퍼플', value: '#800080' },
    { name: '라벤더', value: '#b39ddb' },
    { name: '베이지', value: '#f5deb3' },
    { name: '브라운', value: '#a0522d' },
    { name: '화이트', value: '#ffffff' },
    { name: '아이보리', value: '#f5f5dc' },
    { name: '그레이', value: '#808080' },
    { name: '차콜', value: '#444444' },
    { name: '블랙', value: '#000000' },
    { name: '실버', value: '#c0c0c0' },
    { name: '골드', value: '#ffd700' },
    { name: '혼합', value: 'linear-gradient(45deg, #ff0000, #0000ff, #00ff00, #ffff00)' },
];
